import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setTimeAdvert } from "../../repository/slice";

function* getTimeAdvertWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/badge/admin/list", payload);
        if (isError) {

        } else {
            yield put(setTimeAdvert(data));
        }
    } catch (error) {
        console.error("getTimeAdvertWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getTimeAdvertWatcher() {
    yield takeLatest("@saga/GET_TIME_ADVERT", getTimeAdvertWorker);
};